import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getSettlementService } from '../../../domains/settlement';

const unwrap = (res: any) => {
  if (res?.result_code !== '200' && res?.resultCode !== 200) throw new Error(res?.result_msg || '요청에 실패했습니다.');
  return res.data;
};

/** GET /settlement/paypoint-kpi?month=YYYY-MM → { used_amount, use_count, unique_users, *_delta_pct, settled_ytd } */
export const usePaypointKpi = (month: string, enabled: boolean) =>
  useQuery({
    queryKey: ['paypoint-kpi', month],
    enabled,
    queryFn: async () => unwrap(await getSettlementService().getPaypointKpi(month)),
  });

/** GET /settlement/point-transactions?issuer_type=hq&transaction_type=USE → { items[{amount,status,user_id,created_at}], total } */
export const usePaypointUsages = (pharmacyId: number | undefined, start: string, end: string, page: number, size: number) =>
  useQuery({
    queryKey: ['paypoint-usages', pharmacyId, start, end, page, size],
    enabled: !!pharmacyId,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      unwrap(await getSettlementService().getPointTransactions(pharmacyId, start, end, {
        issuer_type: 'hq', transaction_type: 'USE', limit: size, offset: (page - 1) * size,
      })),
  });
